// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"3b6dedf4","845":"a3baa7ff"}[chunkId] + ".chunk.js";
};